'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _pageActions = require('../actions/page-actions');

var _profileRightSection = require('../actions/profile-right-section');

var _bookHealthCheckModal = require('../actions/book-health-check-modal');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactIntl = require('react-intl');

var _utils = require('../utils/utils');

var _doctifyUtils = require('doctify-utils');

var _practicePage = require('../transformers/practice-page');

var _loadingDots = require('loading-dots');

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _doctifyModals = require('../../../doctify-modals');

var _doctifyGoogleMap = require('../../../doctify-google-map');

var _profileHeader = require('../../../profile-header');

var _profileRightSection2 = require('../../../profile-right-section');

var _headHelmet = require('../../../head-helmet');

var _reactRouter = require('react-router');

var _schemaGenerator = require('schema-generator');

var _reduxSimpleAuth = require('redux-simple-auth');

var _loaders = require('../utils/loaders');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global document navigator setTimeout */

var practicePageLoader = new _doctifyUtils.PageLoader(_loaders.loaders);

/**
	loaders
**/


var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
	messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var globalActions = _doctifyGlobalRedux2.default.globalActions;

var ReviewModalActions = globalActions.ReviewModalActions,
    ReportModalActions = globalActions.ReportModalActions;


var displayPageOr404 = function displayPageOr404(props) {

	if (!props || !props.practice) {
		return false;
	}

	var isInitLoaded = props.practice && props.practice.id;
	var account = props.session && props.session.account;
	var authToken = props.session && props.session.auth_token;
	var isInvalid = props.practice && !['approved', 'verified'].includes(props.practice.status);
	var pageIsNotOwned = props.practice && !(0, _doctifyUtils.pageIsOwned)(props.session, props.practice.id, 'practice');
	var checkNotReady = !isInitLoaded || !props.isRestored;

	if (props.practiceLoadError || !checkNotReady && isInvalid && pageIsNotOwned) {
		if (typeof window !== 'undefined') {
			window.location.href = '/404';
			return false;
		}
		return false;
	}

	if (checkNotReady && !(0, _doctifyUtils.isServerSide)()) {
		return false;
	}

	return true;
};

var PracticePage = function PracticePage(props) {
	props.init(props);

	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			'div',
			{ id: _style2.default.PracticePage },
			_react2.default.createElement(_headHelmet.HeadHelmet, {
				pageTitle: (0, _utils.buildMetaTitle)(props),
				pageContent: (0, _utils.buildMetaDescription)(props),
				pageImage: (props.practice && props.practice.attributes && props.practice.attributes && props.practice.attributes.profile_featured_image) + '_lg.jpg',
				pagePath: (0, _doctifyUtils.getResourcePath)('/practice/' + (props.practice && props.practice.uri_id))
			}),
			props.bookHealthCheckModal.isOpen && _react2.default.createElement(_doctifyModals.BookHealthCheckModal, (0, _extends3.default)({}, props.bookHealthCheckModal, props.bookHealthCheckModalActions, {
				title: props.bookHealthCheckModal.selectedPackage.package_name,
				onSubmit: function onSubmit(requestData) {
					return props.bookHealthCheckModalActions.onSubmit(requestData, props.practice.id);
				},
				onValidatePromoCode: function onValidatePromoCode() {
					props.bookHealthCheckModalActions.onValidatePromoCode(props.bookHealthCheckModal.promoCode, props.practice.id);
				},
				account: props.accountProfileData })),
			_react2.default.createElement('div', { className: _style2.default.topNavBackground }),
			props.practice.id && _react2.default.createElement(_schemaGenerator.SchemaPractice, {
				practiceData: { practice: props.practice, specialists: props.profileRightSectionData.specialists },
				reviewData: { reviews: props.profileRightSectionData.practiceReviews }
			}),
			displayPageOr404(props) && _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: _style2.default.leftColumn },
					_react2.default.createElement(_profileHeader.PracticeProfileHeader, (0, _extends3.default)({}, props.profileHeaderData, {
						onStarsClick: props.scrollToReviews,
						onAddReview: props.reviewModalActions.openReviewModal })),
					_react2.default.createElement(
						'div',
						{ className: _style2.default.about },
						props.practice.address && props.practice.address.position && !!props.practice.address.position.lat && !!props.practice.address.position.lng && _react2.default.createElement(
							'div',
							{ className: '' + _style2.default.detailsColumn },
							_react2.default.createElement(_doctifyGoogleMap.DoctifyGoogleMap, {
								markers: [{ position: props.practice.address.position }],
								iconUrl: (0, _doctifyUtils.getResourcePath)('/img/map-icons/practice.png'),
								center: props.practice.address.position,
								containerElementStyle: { height: '300px' } })
						) || _react2.default.createElement(
							'div',
							{ className: _style2.default.detailsColumn },
							_react2.default.createElement(
								'p',
								{ className: _style2.default.mapNotFoundText },
								'Google Maps could not locate this practice, so we cannot display the map.'
							),
							_react2.default.createElement(
								'p',
								{ className: _style2.default.mapNotFoundText },
								'You may be able to find it by searching on ',
								_react2.default.createElement(
									'a',
									{
										target: '_blank',
										href: 'https://www.google.com/maps/place/' + (props.practice.address.postcode && encodeURIComponent(props.practice.address.postcode) || '') },
									'the Google Maps site.'
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _style2.default.detailsColumn },
							props.practice.address && props.practice.address.street1 && _react2.default.createElement(
								'div',
								{ className: _style2.default.detailsRow },
								_react2.default.createElement(
									'h1',
									null,
									'Address'
								),
								_react2.default.createElement(
									'div',
									null,
									props.practice.address.street1
								),
								_react2.default.createElement(
									'div',
									null,
									props.practice.address.street2
								),
								_react2.default.createElement(
									'div',
									null,
									props.practice.address.postcode,
									props.practice.address.postcode && props.practice.address.city && ', ',
									props.practice.address.city
								)
							),
							(props.practice.attributes.weekday_opening_hours && props.practice.attributes.weekday_opening_hours.start && props.practice.attributes.weekday_opening_hours.end || props.practice.attributes.weekend_opening_hours && props.practice.attributes.weekend_opening_hours.start && props.practice.attributes.weekend_opening_hours.end) && _react2.default.createElement(
								'div',
								{ className: _style2.default.detailsRow },
								_react2.default.createElement(
									'h1',
									null,
									'Opening hours'
								),
								props.practice.attributes.weekday_opening_hours.start && props.practice.attributes.weekday_opening_hours.end && _react2.default.createElement(
									'div',
									null,
									'Mon\u2013Fri: ',
									props.practice.attributes.weekday_opening_hours.start,
									' \u2013 ',
									props.practice.attributes.weekday_opening_hours.end
								),
								props.practice.attributes.weekend_opening_hours.start && props.practice.attributes.weekend_opening_hours.end && _react2.default.createElement(
									'div',
									null,
									'Sat\u2013Sun: ',
									props.practice.attributes.weekend_opening_hours.start,
									' \u2013 ',
									props.practice.attributes.weekend_opening_hours.end
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _style2.default.rightColumn },
					_react2.default.createElement(_profileRightSection2.ProfileRightSection, (0, _extends3.default)({
						className: _style2.default.profileSection
					}, props.profileRightSectionData, props.profileRightSection, props.profileRightSectionActions, {
						onHealthCheckSelected: function onHealthCheckSelected(id) {
							_reactRouter.browserHistory.push(('/practice/' + props.params.id + '?\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedHealthCheck === id.toString() ? '' : 'selectedHealthCheck=' + id + '&') + '\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedScan ? 'selectedScan=' + props.location.query.selectedScan + '&' : '') + '\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedScanPackage ? 'selectedScanPackage=' + props.location.query.selectedScanPackage + '&' : '') + '\n\t\t\t\t\t\t\t\t\t').replace(/\s+/gm, ''));
						},
						onHealthCheckPackageSelected: function onHealthCheckPackageSelected(id) {
							_reactRouter.browserHistory.push(('/practice/' + props.params.id + '?\n\t\t\t\t\t\t\t\t\t\tselectedHealthCheck=' + props.location.query.selectedHealthCheck + '&\n\t\t\t\t\t\t\t\t\t\tselectedHealthCheckPackage=' + id + '&\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedScan ? 'selectedScan=' + props.location.query.selectedScan + '&' : '') + '\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedScanPackage ? 'selectedScanPackage=' + props.location.query.selectedScanPackage : '') + '\n\t\t\t\t\t\t\t\t\t').replace(/\s+/gm, ''));
						},
						onScanSelected: function onScanSelected(id) {
							_reactRouter.browserHistory.push(('/practice/' + props.params.id + '?\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedHealthCheck ? 'selectedHealthCheck=' + props.location.query.selectedHealthCheck + '&' : '') + '\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedHealthCheckPackage ? 'selectedHealthCheckPackage=' + props.location.query.selectedHealthCheckPackage + '&' : '') + '\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedScan === id.toString() ? '' : 'selectedScan=' + id) + '\n\t\t\t\t\t\t\t\t\t').replace(/\s+/gm, ''));
						},
						onScanPackageSelected: function onScanPackageSelected(id) {
							_reactRouter.browserHistory.push(('/practice/' + props.params.id + '?\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedHealthCheck ? 'selectedHealthCheck=' + props.location.query.selectedHealthCheck + '&' : '') + '\n\t\t\t\t\t\t\t\t\t\t' + (props.location.query.selectedHealthCheckPackage ? 'selectedHealthCheckPackage=' + props.location.query.selectedHealthCheckPackage + '&' : '') + '\n\t\t\t\t\t\t\t\t\t\tselectedScan=' + props.location.query.selectedScan + '&\n\t\t\t\t\t\t\t\t\t\tselectedScanPackage=' + id + '\n\t\t\t\t\t\t\t\t\t').replace(/\s+/gm, ''));
						},
						activeHealthChecks: {
							healthCheck: props.location.query && parseInt(props.location.query.selectedHealthCheck) || null,
							scan: props.location.query && parseInt(props.location.query.selectedScan) || null
						},
						activePackages: {
							healthCheck: props.location.query && parseInt(props.location.query.selectedHealthCheckPackage) || null,
							scan: props.location.query && parseInt(props.location.query.selectedScanPackage) || null
						},
						onBookButtonClicked: function onBookButtonClicked(packageData) {
							(0, _doctifyUtils.fireGTMevent)('health_check_pp_click');
							props.bookHealthCheckModalActions.openModal(packageData, props.accountProfileData);
						},
						setPackageType: props.bookHealthCheckModalActions.setPackageType,
						expandableSectionClicked: props.toggleSection,
						specialistListSelectionChanged: props.updateSpecialists,
						headerClicked: _doctifyUtils.scrollTo,
						isLoggedIn: props.isAuthenticated,
						likeButtonClicked: function likeButtonClicked(isLiked, index) {
							if (props.isAuthenticated) {
								props.toggleLike({
									id: props.profileRightSectionData.practiceReviews[index].id,
									auth: props.session.auth_token,
									author: props.session.account.id
								});
							}
						},
						reportReviewClicked: props.reportModalActions.openReportModal
					}))
				)
			),
			props.reportModal.isOpen && _react2.default.createElement(_doctifyModals.ReportModal, (0, _extends3.default)({}, props.reportModal, props.reportModalActions, {
				closeModal: props.reportModalActions.closeReportModal,
				sendReportModal: function sendReportModal(review) {
					var url = (0, _utils.getReviewReportUrl)(review);
					var data = { reson_for_flag: props.reportModal.reportText, reporting_email: props.reportModal.reportEmail };
					props.reportModalActions.sendReportModal(url, data);
				}
			})),
			!displayPageOr404(props) && _react2.default.createElement(_loadingDots.LoadingDots, { centered: true })
		)
	);
};

PracticePage.propTypes = {
	params: require('react').PropTypes.shape({
		id: require('react').PropTypes.any.isRequired
	}).isRequired,
	reportModal: require('react').PropTypes.shape({
		isOpen: require('react').PropTypes.bool.isRequired
	}).isRequired,
	practice: require('react').PropTypes.shape({
		id: require('react').PropTypes.any.isRequired,
		practiceLoadError: require('react').PropTypes.bool,
		uri_id: require('react').PropTypes.any.isRequired,
		address: require('react').PropTypes.shape({
			street1: require('react').PropTypes.any.isRequired,
			street2: require('react').PropTypes.any.isRequired,
			city: require('react').PropTypes.any.isRequired,
			postcode: require('react').PropTypes.any.isRequired,
			position: require('react').PropTypes.shape({
				lat: require('react').PropTypes.any.isRequired,
				lng: require('react').PropTypes.any.isRequired
			}).isRequired
		}).isRequired,
		attributes: require('react').PropTypes.shape({
			weekday_opening_hours: require('react').PropTypes.shape({
				start: require('react').PropTypes.any.isRequired,
				end: require('react').PropTypes.any.isRequired
			}).isRequired,
			weekend_opening_hours: require('react').PropTypes.shape({
				start: require('react').PropTypes.any.isRequired,
				end: require('react').PropTypes.any.isRequired
			}).isRequired,
			profile_featured_image: require('react').PropTypes.any.isRequired
		}).isRequired,
		email: require('react').PropTypes.any.isRequired,
		phone: require('react').PropTypes.any.isRequired,
		status: require('react').PropTypes.any.isRequired
	}).isRequired,
	showModal: require('react').PropTypes.any.isRequired,
	payload: require('react').PropTypes.object.isRequired,
	promoCode: require('react').PropTypes.any.isRequired,
	location: require('react').PropTypes.shape({
		query: require('react').PropTypes.any.isRequired
	}).isRequired,
	profileHeaderData: require('react').PropTypes.object.isRequired,
	profileRightSection: require('react').PropTypes.object.isRequired,
	profileRightSectionData: require('react').PropTypes.object.isRequired,
	bookHealthCheckModal: require('react').PropTypes.object.isRequired,
	session: require('react').PropTypes.object.isRequired,
	accountProfileData: require('react').PropTypes.object.isRequired,
	pageActions: require('react').PropTypes.object.isRequired,
	profileRightSectionActions: require('react').PropTypes.object.isRequired,
	reviewModalActions: require('react').PropTypes.object.isRequired,
	isAuthenticated: require('react').PropTypes.object.isRequired,
	sessionActions: require('react').PropTypes.object.isRequired,
	bookHealthCheckModalActions: require('react').PropTypes.object.isRequired,
	isInitLoaded: require('react').PropTypes.bool.isRequired,
	init: require('react').PropTypes.func.isRequired,
	updateActiveScan: require('react').PropTypes.func.isRequired,
	updateActiveScanPackage: require('react').PropTypes.func.isRequired,
	bookSelectedPackage: require('react').PropTypes.func.isRequired,
	toggleSection: require('react').PropTypes.func.isRequired,
	updateSpecialists: require('react').PropTypes.func.isRequired,
	updateFirstName: require('react').PropTypes.func.isRequired,
	updateLastName: require('react').PropTypes.func.isRequired,
	updateEmail: require('react').PropTypes.func.isRequired,
	updatePhone: require('react').PropTypes.func.isRequired,
	updateReasonForVisit: require('react').PropTypes.func.isRequired,
	updatePromoCode: require('react').PropTypes.func.isRequired,
	applyPromoCode: require('react').PropTypes.func.isRequired,
	submitForm: require('react').PropTypes.func.isRequired,
	closeModal: require('react').PropTypes.func.isRequired,
	scrollToReviews: require('react').PropTypes.func.isRequired,
	toggleLike: require('react').PropTypes.func.isRequired
};
var mapStateToProps = function mapStateToProps(state) {
	return {
		reportModal: state.global.reportModal,
		loadedUri: state.practicePage.page.loadedUri,
		isInitLoaded: state.practicePage.page.isInitLoaded,
		practiceLoadError: state.practicePage.page.practiceLoadError,
		topNav: state.global.topNav,
		session: (0, _reduxSimpleAuth.getSessionData)(state),
		isRestored: (0, _reduxSimpleAuth.getIsRestored)(state),
		isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state),
		practice: (0, _practicePage.transformPractice)(state.practicePage.page.practice.practice),
		listings: state.global.listings,
		showModal: state.practicePage.page.showModal,
		payload: state.practicePage.page.payload,
		profileHeaderData: {
			name: state.practicePage.page.practice.practice.name,
			profileImage: state.practicePage && state.practicePage.page && state.practicePage.page.practice && state.practicePage.page.practice.practice && state.practicePage.page.practice.practice.attributes && state.practicePage.page.practice.practice.attributes.profile_logo && state.practicePage.page.practice.practice.attributes.profile_logo + '_lg.jpg' || '',
			averageRating: state.practicePage.page.practice.practice.average_review,
			totalReviews: state.practicePage.page.practice.practice.number_of_reviews,
			backgroundImage: state.practicePage.page && state.practicePage.page.practice && state.practicePage.page.practice.practice && state.practicePage.page.practice.practice.attributes && state.practicePage.page.practice.practice.attributes.profile_cover && state.practicePage.page.practice.practice.attributes.profile_cover + '_lg.jpg' || '',
			photos: state.practicePage.page && state.practicePage.page.practice && state.practicePage.page.practice.practice && state.practicePage.page.practice.practice.attributes && state.practicePage.page.practice.practice.attributes.profile_images && state.practicePage.page.practice.practice.attributes.profile_images.map(function (image) {
				return image + '_lg.jpg';
			}) || [],
			isNhs: state.practicePage.page && state.practicePage.page.practice && state.practicePage.page.practice.practice && state.practicePage.page.practice.practice.is_nhs
		},
		profileRightSectionData: {
			practiceId: state.practicePage.page.practice.practice.id,
			practiceSpecialties: (0, _practicePage.transformSpecialties)(state.global.listings.specialties, state.practicePage.page.practice.specialists),
			practiceAbout: state.practicePage.page && state.practicePage.page.practice && state.practicePage.page.practice.practice && state.practicePage.page.practice.practice.attributes && state.practicePage.page.practice.practice.attributes.about || '',
			practiceInsurers: (0, _practicePage.transformInsurers)(state.practicePage.page.practice.practice.insurers, state.global.listings.insurers),
			healthChecks: state.practicePage.page.practice.practice.health_checks,
			practiceAboutSectionExpanded: state.practicePage.page.practiceAboutSectionExpanded,
			specialists: (0, _practicePage.transformSpecialists)(state.practicePage.page.specialists, state.global.listings.specialties),
			topLevelSpecialties: (0, _practicePage.transformTopLevelSpecialties)(state.practicePage.page.practice.specialists),
			selectedPackage: state.practicePage.page.selectedPackage,
			promoCode: state.practicePage.page.promoCode,
			practiceReviews: state.practicePage.page.practiceReviews,
			profileImage: state.practicePage && state.practicePage.page && state.practicePage.page.practice && state.practicePage.page.practice.practice && state.practicePage.page.practice.practice.attributes && state.practicePage.page.practice.practice.attributes.profile_logo && state.practicePage.page.practice.practice.attributes.profile_logo + '_lg.jpg' || ''
		},
		profileRightSection: state.practicePage.profileRightSection,
		// Refactor required here - line above is how data should be mapped to props.
		// Currently lots of information is on state.practicePage.page - move as much as possible out to be self-contained.
		bookHealthCheckModal: state.practicePage.bookHealthCheckModal,
		accountProfileData: state.global.accountProfileData
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		sessionActions: (0, _redux.bindActionCreators)({ invalidateSession: _reduxSimpleAuth.invalidateSession }, dispatch),
		pageActions: (0, _redux.bindActionCreators)(_pageActions.PageActions, dispatch),
		profileRightSectionActions: (0, _redux.bindActionCreators)(_profileRightSection.ProfileRightSectionActions, dispatch),
		reviewModalActions: (0, _redux.bindActionCreators)(ReviewModalActions, dispatch),
		bookHealthCheckModalActions: (0, _redux.bindActionCreators)(_bookHealthCheckModal.BookHealthCheckModalActions, dispatch),
		reportModalActions: (0, _redux.bindActionCreators)(ReportModalActions, dispatch),
		init: function init(props) {
			if (typeof window !== 'undefined') {
				practicePageLoader.runOnce(dispatch, props, null, { _id_: props.params && props.params.id }).then(function (isFirstLoad) {
					if (isFirstLoad) {
						props.pageActions.initLoaded();
					} else if (props.isInitLoaded) {
						props.mapUrlToProps(props);
					}
				});
			}
		},
		mapUrlToProps: function mapUrlToProps(props) {
			if (props.params.id !== props.loadedUri) {
				props.pageActions.loadUri(props.params.id);
				dispatch(_pageActions.PageActions.trackViewsFromSearch(props.params.id));
				dispatch(_pageActions.PageActions.loadPracticeProfile(props.params.id));
				dispatch(_pageActions.PageActions.loadPracticeReviews(props.params.id));
			}
		},
		bookSelectedPackage: function bookSelectedPackage(packageData) {
			dispatch(_pageActions.PageActions.bookSelectedPackage(packageData));
		},
		toggleSection: function toggleSection(sectionExpanded, sectionName) {
			dispatch(_pageActions.PageActions.toggleSection(sectionExpanded, sectionName));
		},
		updateSpecialists: function updateSpecialists(specialty) {
			dispatch(_pageActions.PageActions.updateSpecialists(specialty));
		},
		toggleLike: function toggleLike(payload) {
			dispatch(_pageActions.PageActions.toggleLike(payload));
		},
		applyPromoCode: function applyPromoCode() {
			return dispatch(_pageActions.PageActions.applyPromoCode());
		},
		submitForm: function submitForm() {
			return dispatch(_pageActions.PageActions.submitForm());
		},

		closeModal: function closeModal() {
			return dispatch(_pageActions.PageActions.closeModal());
		},
		updateFirstName: function updateFirstName(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('firstname', newValue));
		},
		updateLastName: function updateLastName(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('lastname', newValue));
		},
		updateEmail: function updateEmail(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('email', newValue));
		},
		updatePhone: function updatePhone(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('phone', newValue));
		},
		updateGender: function updateGender(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('gender', newValue));
		},
		updateBirthdateDay: function updateBirthdateDay(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('birthday', newValue));
		},
		updateBirthdateMonth: function updateBirthdateMonth(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('birthmonth', newValue));
		},
		updateBirthdateYear: function updateBirthdateYear(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('birthyear', newValue));
		},
		updateReasonForVisit: function updateReasonForVisit(newValue) {
			return dispatch(_pageActions.PageActions.updatePayload('message', newValue));
		},
		updatePromoCode: function updatePromoCode(newValue) {
			return dispatch(_pageActions.PageActions.updatePromoCode(newValue));
		},
		scrollToReviews: function scrollToReviews() {
			var SCROLL_DURATION = 500;
			dispatch(_profileRightSection.ProfileRightSectionActions.setSectionActive('Reviews'));
			dispatch(_profileRightSection.ProfileRightSectionActions.disableScrollHighlight());
			(0, _doctifyUtils.scrollTo)(document.getElementById('practiceReviews'), document.getElementById('scrolldiv'), SCROLL_DURATION);
			setTimeout(function () {
				dispatch(_profileRightSection.ProfileRightSectionActions.disableScrollHighlight());
			}, SCROLL_DURATION);
		}
	};
};

PracticePage.displayName = 'PracticePage';

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PracticePage);


// WEBPACK FOOTER //
// ./components/practice-page/lib/components/practice-page.js